import { useEffect, useState } from 'react'
import { Typography } from 'amo-styling-library'
import { SimpleDashboardLayout } from '../components/layout/SimpleDashboardLayout'
import { API_ENDPOINTS } from '../config/api'

interface Stats {
  totalTrips: number
  totalActivities: number
  totalActivityTypes: number
  activeTrips: number
  cancelledTrips: number
}

function StartPage() {
  console.log('StartPage component rendering')
  const [stats, setStats] = useState<Stats | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    console.log('StartPage useEffect - fetching stats from:', API_ENDPOINTS.stats)
    fetch(API_ENDPOINTS.stats)
      .then(res => {
        console.log('Stats response received:', res.status)
        return res.json()
      })
      .then(data => {
        console.log('Stats data:', data)
        setStats(data)
        setLoading(false)
      })
      .catch(err => {
        console.error('Failed to load stats:', err)
        setLoading(false)
      })
  }, [])

  if (loading) {
    return (
      <SimpleDashboardLayout>
        <div className="bg-white rounded-lg p-6 h-full">
          <Typography variant="h2" className="text-gray-900 mb-6">
            Start
          </Typography>
          <p className="text-gray-600">Laden...</p>
        </div>
      </SimpleDashboardLayout>
    )
  }

  return (
    <SimpleDashboardLayout>
      <div className="bg-white rounded-lg p-6 h-full">
        <Typography variant="h2" className="text-gray-900 mb-6">
          Dashboard
        </Typography>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {/* Total Trips */}
          <div className="p-6 border border-gray-200 rounded-lg bg-white shadow-sm">
            <Typography variant="body1" className="text-gray-500 mb-2">
              Totaal Ritten
            </Typography>
            <Typography variant="h1" style={{ color: '#DA0000', fontSize: '36px' }}>
              {stats?.totalTrips || 0}
            </Typography>
          </div>

          {/* Active Trips */}
          <div className="p-6 border border-gray-200 rounded-lg bg-white shadow-sm">
            <Typography variant="body1" className="text-gray-500 mb-2">
              Actieve Ritten
            </Typography>
            <Typography variant="h1" style={{ color: '#10B981', fontSize: '36px' }}>
              {stats?.activeTrips || 0}
            </Typography>
          </div>

          {/* Total Activities */}
          <div className="p-6 border border-gray-200 rounded-lg bg-white shadow-sm">
            <Typography variant="body1" className="text-gray-500 mb-2">
              Totaal Activiteiten
            </Typography>
            <Typography variant="h1" style={{ color: '#2D2C3C', fontSize: '36px' }}>
              {stats?.totalActivities || 0}
            </Typography>
          </div>

          {/* Cancelled Trips */}
          <div className="p-6 border border-gray-200 rounded-lg bg-white shadow-sm">
            <Typography variant="body1" className="text-gray-500 mb-2">
              Geannuleerde Ritten
            </Typography>
            <Typography variant="h1" style={{ color: '#EF4444', fontSize: '36px' }}>
              {stats?.cancelledTrips || 0}
            </Typography>
          </div>
        </div>

        {/* Welcome Section */}
        <div className="p-8 border border-gray-200 rounded-lg bg-gray-50">
          <Typography variant="h3" className="text-gray-900 mb-4">
            Welkom bij LDH Trans
          </Typography>
          <Typography variant="body1" className="text-gray-600 leading-relaxed mb-4">
            Dit is het LDH Trans beheerportaal. Gebruik het menu aan de linkerkant om te navigeren naar de verschillende secties.
          </Typography>
          <ul className="list-disc list-inside text-gray-600 space-y-2">
            <li>Bekijk en beheer containers</li>
            <li>Bekijk ritten en activiteiten</li>
            <li>Beheer gebruikers (Admin/Manager)</li>
            <li>Bekijk berichten in de inbox</li>
          </ul>
        </div>
      </div>
    </SimpleDashboardLayout>
  )
}

export default StartPage
